import { c as _c } from "react/compiler-runtime";
import { Button, ButtonProps } from '@udemy-v2/react-core-components';
import classNames from 'classnames';
import React from 'react';
import styles from './show-more-button.module.scss';
export const ShowMoreButton = t0 => {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = classNames(className, "ud-link-underline", styles.button);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== rest || $[6] !== t1) {
    t2 = <Button {...rest} udStyle="ghost" className={t1} />;
    $[5] = rest;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};